const UserSettings = () => {
  return <div className="main-dash-content">Manage User Settings</div>;
};

export default UserSettings;
